import { defineComponent as _defineComponent } from 'vue'
import { mastersService } from '@/services/masters.service';
import { TagInput } from '@/components/common/tagInput';
import { computed } from 'vue';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'EventCodesFilter',
  props: {
    value: { default: () => [] },
    position: { default: 'is-bottom-left' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: string[]) => void), expose: any, slots: any, attrs: any }) {





const { t } = useI18n();

function emitValue(event: string | number | (string | number)[]) {
  emit('input', event as string[]);
}

const availableCodes = computed<string[]>(() =>
  mastersService.store.getEventCodes(),
);

return { __sfc: true,emit, t, emitValue, availableCodes, TagInput }
}

})